import React from 'react';
import { Box, Typography, CircularProgress, MenuItem, Select, FormControl, InputLabel, Tooltip } from '@mui/material';

function StatusDot({ state }) {
  const color = state === 'Connected' ? '#4caf50' : state === 'Disconnected' ? '#f44336' : '#9e9e9e';
  return (
    <Box
      component="span"
      sx={{ display: 'inline-block', width: 8, height: 8, borderRadius: '50%', backgroundColor: color, mr: 0.8, flexShrink: 0 }}
    />
  );
}

function DTGatewayPicker({ gateways, selectedGatewayId, onChange, loading, theme }) {
  const isDark = theme === 'dark';
  return (
    <FormControl size="small" fullWidth>
      <InputLabel sx={{ color: isDark ? '#aaa' : undefined }}>Gateway</InputLabel>
      <Select
        value={selectedGatewayId || ''}
        label="Gateway"
        onChange={(e) => onChange(e.target.value || null)}
        disabled={loading}
        startAdornment={loading ? <CircularProgress size={14} sx={{ mr: 1 }} /> : null}
        sx={{ color: isDark ? '#fff' : undefined }}
        MenuProps={{ PaperProps: { sx: { backgroundColor: isDark ? '#252525' : undefined } } }}
      >
        <MenuItem value="">
          <em style={{ color: isDark ? '#aaa' : undefined }}>All Gateways</em>
        </MenuItem>
        {gateways.map((gw) => (
          <Tooltip
            key={gw.GatewayID}
            title={gw.connectionState || 'Status unknown'}
            placement="right"
          >
            <MenuItem
              value={gw.GatewayID}
              sx={{ color: isDark ? '#fff' : undefined }}
            >
              <StatusDot state={gw.connectionState} />
              {gw.Name || gw.SN || gw.GatewayID}
              {gw.SN && gw.Name && (
                <Typography variant="caption" sx={{ ml: 0.5, color: isDark ? '#888' : '#999' }}>
                  ({gw.SN})
                </Typography>
              )}
            </MenuItem>
          </Tooltip>
        ))}
      </Select>
    </FormControl>
  );
}

export default React.memo(DTGatewayPicker);
